import * as yup from "yup";
import { emailRegEx } from "./RegEx";

export const contactSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  lastName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  email: yup
    .string()
    .matches(emailRegEx, "Should be valid email")
    .required("Email is required"),
  reason: yup.string().required("Reason is required"),
  message: yup
    .string()
    .min(10, "Must be at least 10 char")
    .max(500, "Must be at most 500 char"),
});
